const strings = {
  audit: {
    title: 'Auditoria',
    subtitle: 'Auditar',
    open: 'Abrir',
  },
}

export default strings
